// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

export function PlusThin() {
  return (
    <svg
      width="24"
      height="24"
      aria-label="Plus Thin"
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Plus Thin</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 3H11.5V11.5H3V12.5H11.5V21H12.5V12.5H21V11.5H12.5V3Z"
        fill="currentColor"
      />
    </svg>
  );
}

interface PlusProps {
  className?: string;
  title?: string;
}

export function Plus({ className, title }: PlusProps) {
  const _title = title || 'Plus';

  return (
    <svg
      className={className}
      width="24"
      height="24"
      aria-label={_title}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{_title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 3H11V11H3V13H11V21H13V13H21V11H13V3Z"
        fill="currentColor"
      />
    </svg>
  );
}

type PlusStrokeProps = {
  title?: string;
};

export function PlusStroke({ title = 'Plus Stroke' }: PlusStrokeProps) {
  return (
    <svg
      width="24"
      height="24"
      aria-label={title}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 11V6H13V11H18V13H13V18H11V13H6V11H11Z"
        fill="currentColor"
      />
    </svg>
  );
}

type PlusThinStrokeProps = {
  title?: string;
};

export function PlusThinStroke({
  title = 'Plus Thin Stroke',
}: PlusThinStrokeProps) {
  return (
    <svg
      width="24"
      height="24"
      aria-label={title}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.5 11.5V6H12.5V11.5H18V12.5H12.5V18H11.5V12.5H6V11.5H11.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
